function SectionBtn(data){
    return (
        <button type="button" onClick={() => data.func()} className={`sectionBtn ${data.btnAddClass ? data.btnAddClass : ""}`} dangerouslySetInnerHTML={{__html:data.text}}></button>
    );
}

export {SectionBtn};